import { render, staticRenderFns } from "./SyncForm.vue?vue&type=template&id=1e25cc68"
import script from "./SyncForm.vue?vue&type=script&lang=ts"
export * from "./SyncForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports